/** @internal */
export const OP_DONE = "Done" as const

/** @internal */
export type OP_DONE = typeof OP_DONE

/** @internal */
export const OP_SUSPEND = "Suspend" as const

/** @internal */
export type OP_SUSPEND = typeof OP_SUSPEND
